import { render, staticRenderFns } from "./ListGuestItem.vue?vue&type=template&id=37c50056&"
import script from "./ListGuestItem.vue?vue&type=script&lang=js&"
export * from "./ListGuestItem.vue?vue&type=script&lang=js&"
import style0 from "./ListGuestItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Link: require('/app/components/link/Link.vue').default})
